import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AppService } from '../../../core/service/app.service';
import { CoreApiService } from '../../../core/service/core-api-service';
import { properties } from '../../../../environments/properties';
import { CalendarModule } from 'primeng/calendar';
import { DocumentDriverModel } from '../../../model/document.driver.model';

@Component({
  selector: 'app-create-publicity',
  standalone: true,
  imports: [
    StepperModule,
    ButtonModule,
    InputTextModule,
    ToggleButtonModule,
    CommonModule,
    FormsModule,
    FloatLabelModule,
    ReactiveFormsModule,
    TableModule,
    FileUploadModule,
    ImageModule,
    DropdownModule,
    CheckboxModule,
    RouterLink,
    CalendarModule,
  ],
  templateUrl: './create-publicity.component.html',
  styleUrl: './create-publicity.component.css',
})
export class CreatePublicityComponent implements OnInit {
  titulo: string = 'Crear Publicidad';
  step1_titulo: string = 'Datos de la publicidad';
  step2_titulo: string = 'Imagen de la publicidad';
  step3_titulo: string = 'Hecho';
  active: number = 0;
  ltsStates: any[] = [];
  selectedState: any = null;
  document: DocumentDriverModel | null = null;
  loading: boolean = false;
  ltsTypePublicity: any[] = [];
  filstring: string = '';
  selectedTypePublicity: any | undefined;
  minDateToday: Date = new Date(new Date().setHours(0, 0, 0, 0));
  formPublicity!: FormGroup;

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getListPoliticalDivision();
    this.getLtsTypePublicity();
    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(startDate.getDate() + 10);
    this.formPublicity = new FormGroup({
      pub_tilte: new FormControl('', Validators.required),
      pub_description: new FormControl('', Validators.required),
      pub_url_site: new FormControl('', Validators.required),
      pub_date_start: new FormControl(startDate, Validators.required),
      pub_date_end: new FormControl(endDate, Validators.required),
      pub_state_id: new FormControl('', Validators.required),
      pub_publicity_type_id: new FormControl('', Validators.required),
    });
  }

  getLtsTypePublicity(): void {
    this.loading = true;
    this.apiService.consumirWSGet(
      properties.serviceGetAllTypePublicity,
      '',
      (data) => {
        this.ltsTypePublicity = data.data;
        this.selectedTypePublicity = this.ltsTypePublicity[0];
        this.loading = false;
      },
    );
  }

  getListPoliticalDivision(): void {
    this.apiService.consumirWSGet(
      properties.servicePoliticalDivisions,
      null,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsStates = data.data;
        } else {
          this.util.mostrarToast(
            'Lista de Estados',
            'Error al obtener la lista de estados',
            4,
          );
        }
      },
    );
  }

  next(): void {
    this.active++;
  }

  back(): void {
    this.active--;
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    const doc = files[0];
    this.removeFile();
    const filestring = await this.previewFile(doc);
    this.document = {
      dri_doc_dri_id: 0,
      dri_doc_doc_id: 0,
      dri_doc_company: this.util.returnEmpresa(),
      dri_doc_typ_codigo: 0,
      file: doc,
      filstring: filestring,
      typeDocument: 0,
    };
    fileUpload.clear();
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {};
    });
  }

  removeFile() {
    this.document = null;
  }
  createPublicity(): void {
    if (this.document != null && this.formPublicity) {
      const formData = new FormData();
      const dateEnd = this.formPublicity.get('pub_date_end')?.value;
      const dateStart = this.formPublicity.get('pub_date_start')?.value;
      formData.append(
        'pub_tilte',
        this.formPublicity.get('pub_tilte')?.value ?? '',
      );
      formData.append(
        'pub_description',
        this.formPublicity.get('pub_description')?.value ?? '',
      );
      formData.append(
        'pub_url_site',
        this.formPublicity.get('pub_url_site')?.value ?? '',
      );
      formData.append(
        'pub_date_start',
        dateStart ? dateStart.toISOString().split('T')[0] : '',
      );
      formData.append(
        'pub_date_end',
        dateEnd ? dateEnd.toISOString().split('T')[0] : '',
      );
      formData.append(
        'pub_state_id',
        this.formPublicity.get('pub_state_id')?.value ?? '',
      );
      formData.append(
        'pub_publicity_type_id',
        this.formPublicity.get('pub_publicity_type_id')?.value ?? '',
      );
      formData.append('pub_channel', '1');
      formData.append(`file`, this.document.file, this.document.file.name);

      this.loading = true;
      this.apiService.consumirWSFilePost(
        properties.serviceCreatePublicity,
        formData,
        (data) => {
          if (data.estado === properties.codeOK) {
            this.loading = false;
            this.next();
            this.formPublicity?.reset();
            this.document = null;
            this.util.mostrarToast(
              'Crear Publicidad',
              'Se ha creado la Publicidad',
              1,
            );
          } else {
            this.util.mostrarToast(
              'Crear Publicidad',
              'Error al crear la publicidad',
              4,
            );
          }
        },
      );
    } else {
      this.util.mostrarToast(
        'Crear Publicidad',
        'Debe tener una imagen de publicidad',
        3,
      );
    }
  }
}
